module.exports = __webpack_public_path__ + "static/media/6.fcc47943.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/6.png
// module id = 962
// module chunks = 0